import { IDataSource } from 'core-components/types/ICrudHelpers'

export const QBR_ATTACHMENTS_DATA_SOURCE: IDataSource = {
  formId: '1559',
  code: 'qbr-attachments-1559',
}
